import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';
import { PayoutRecord } from '../_models';

@Injectable({ providedIn: 'root' })
export class PayoutService {

    constructor(private http: HttpClient) { }

    export(source, country, month): Observable<any> { //export
      return this.http.get(`${environment.apiUrl}/payout/report/export?source=${source}&country=${country}&month=${month}`);
    }

    verify(source, country, month): Observable<any> { //export
      return this.http.get(`${environment.apiUrl}/payout/record/verify?source=${source}&country=${country}&month=${month}`);
    }


    uploadRecords(formData): Observable<any> {
      return this.http.post(`${environment.apiUrl}/payout/record/upload`, formData)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<any>  { //listing
      return this.http.post(`${environment.apiUrl}/payout/record/list`, filter)
      .pipe(
        map((data: any) => {
          if(data.status !== 1 || (data.status == 1 && !data.data.list)){
            return {status: null, msg: data.msg};
          }else{
            return new ListResponse().deserialize(data, PayoutRecord);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteRecord(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/payout/record/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }
}
